import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getReaReportReq,
  getReaReportRes,
  getReaReportResClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import axios from "axios";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import { useTranslation } from "react-i18next";
const ChooseREA = (props) => {
  const {
    selectedTeamMatesList,
    setSelectedTeamMatesList,
    parentId,
    parentName,
    isMobile,
    selectedBrokerageList,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { courseId } = useParams();

  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);
  const reaListRes = useSelector((state) => state.assignCourse.reaReportList);

  const assignedUserRes = useSelector(
    (state) => state.assignCourse.assignedUsers
  );
  const [searchInput, setSearchInput] = useState("");
  const [reaList, setREAList] = useState([]);
  const [optionValue, setOptionValue] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [reaOptList, setREAOptList] = useState([]);
  const [reaDFOptList, setREADFOptList] = useState([
    { value: -1, label: "Type 3 or more characters to start searching" },
  ]);
  const [defaultList, setDefaultList] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  console.log("def--".defaultValue);

  const defaultValue1 = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  useEffect(() => {
    if (
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      dispatch(getReaReportRes());
      console.log("rea load 1");
      searchREA();
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [dispatch, authBroker, authIframeBroker]);

  useEffect(() => {
    if (
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      setSelectedTeamMatesList([]);
      setREAOptList([]);
      console.log("rea load 2");
      searchREA();
      setIsLoading(true);
    }
  }, [selectedBrokerageList, authBroker, authIframeBroker]);
  // let defaultValue = [];
  useEffect(() => {
    setSelectedCount(selectedTeamMatesList?.length);

    const newDefaultValue = selectedTeamMatesList?.map((office) => ({
      value: office.user_id,
      label: office.name,
    }));
    console.log(newDefaultValue);
    setOptionValue(newDefaultValue);
    setDefaultValue(newDefaultValue);
    console.log("stl--", selectedTeamMatesList, defaultValue);
  }, [selectedTeamMatesList]);

  useEffect(() => {
    console.log("defVal--", defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchREA();
    else setErrorMsg("");
  }, [searchInput]);

  const searchREA = () => {
    console.log("rea load 3", selectedBrokerageList);
    dispatch(
      getReaReportReq({
        module: "getTeamMatesList",
        from: "REA",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
          type: "report",
          instructor: window.location.pathname.includes("systemusage-report")
            ? true
            : false,
          content_type: parentName,
          content_ids: [parentId],
          brokerage: selectedBrokerageList,
        },
      })
    );
  };

  useEffect(() => {
    // console.log("reaListRes: ", reaListRes);
    if (!_.isEmpty(reaListRes)) {
      if (reaListRes?.status === "success") {
        let list = reaListRes?.payload?.payload;
        console.log("team list ", list);
        setREAList(list);
        setREAOptList(
          _.map(list, (office) => {
            return {
              value: office.user_id,
              label: office.name,
            };
          })
        );
      } else {
        setREAList([]);
        if (!_.isEmpty(searchInput) && searchInput?.length > 2) {
          setErrorMsg(t("No result found for your search."));
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false);
      // dispatch(getReaReportResClear())
    } else {
      setErrorMsg("");
      setREAList([]);
    }
  }, [reaListRes]);

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(reaList);
    let selectedTempArray = _.cloneDeep(selectedTeamMatesList);
    if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 0)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedTeamMatesList(selectedTempArray);
    tempArr.splice(index, 1);
    setREAList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedTeamMatesList);
    let tempArr = _.cloneDeep(reaList);

    if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 0)) {
      tempArr.push(selectedTempArray[index]);
    }

    setREAList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedTeamMatesList(selectedTempArray);
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if (inputValue.length >= 3) {
        setTimeout(async () => {
          console.log(inputValue);
          let optList = [];
          await axios({
            method: "post",
            url: `${CONFIG.API_URL_REAL_BROKER}${API_LIST.API_ROUTES_REAL_BROKER.GET_TEAMMATES_LIST}`,
            data: {
              token: isMobile
                ? localStorage.getItem(SessionKeys.API_TOKEN)
                : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              search: inputValue,
              type: "report",
              instructor: window.location.pathname.includes(
                "systemusage-report"
              )
                ? true
                : false,
              content_type: parentName,
              content_ids: [parentId],
              brokerage: selectedBrokerageList,
            },
          }).then((response) => {
            console.log(response);
            if (response.data.status) {
              const rList = response.data.data;
              // setManagerList(mList)
              optList = _.map(rList, (rea) => {
                return {
                  value: rea.user_id,
                  label: rea.name,
                };
              });
            }
          });
          resolve(optList);
        }, 1000);
      }
    });

  return (
    <>
      <div className="chooseteamate">
        <h4>{t("Choose End Users")}</h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label">
            {t("Search")}
          </label>
          {!(
            authBroker.payload?.user?.is_corporate ||
            authIframeBroker.payload?.user?.is_corporate
          ) ? (
            <Select
              isMulti
              name="colors"
              className="basic-multi-select w-100 multi-label-select"
              classNamePrefix="xsel"
              placeholder="Select"
              options={reaOptList}
              value={defaultValue}
              isLoading={isLoading}
              onChange={(e) => {
                console.log(e);
                // setSelectedOffice(e)
                if (!_.isEmpty(e)) {
                  setErrorMsg("");
                  let data = [];
                  console.log(reaList);
                  for (let user of reaList) {
                    for (let sO of e) {
                      if (_.toNumber(sO.value) === _.toNumber(user.user_id)) {
                        data.push(user);
                      }
                    }
                  }
                  console.log("set data", data);
                  setSelectedTeamMatesList(data);
                } else {
                  setSelectedTeamMatesList([]);
                  // setErrorMsg("Please select at lease one rea.");
                }
              }}
            />
          ) : (
            <AsyncSelect
              isMulti
              cacheOptions
              name="learner"
              className="basic-multi-select w-100 multi-label-select"
              classNamePrefix="xsel"
              placeholder="Select End Users..."
              isLoading={isLoading}
              defaultOptions={reaDFOptList}
              loadOptions={promiseOptions}
              value={optionValue}
              onChange={(e) => {
                if (_.isArray(e)) {
                  console.log(e);
                  let newArr = [];
                  let value = [];
                  for (let p of e) {
                    if (p.value != "-1") {
                      newArr.push(p);
                      value.push({
                        user_id: p.value,
                        name: p.label,
                      });
                      // console.log(e)
                      // value.push(e.value)
                    }
                  }
                  console.log(newArr);
                  console.log(value);
                  setOptionValue(newArr);
                  setSelectedTeamMatesList(value);
                }
              }}
            />
          )}
        </div>
        <p className="error-msg">{errorMsg}</p>
      </div>
    </>
  );
};

export default ChooseREA;
